/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Run_RetryInputs */

const en_automation_run_retry = /** @type {(inputs: Automation_Run_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const pt_br2_automation_run_retry = /** @type {(inputs: Automation_Run_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar novamente`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Automation_Run_RetryInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_run_retry = /** @type {((inputs?: Automation_Run_RetryInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Run_RetryInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_run_retry(inputs)
	return pt_br2_automation_run_retry(inputs)
});